(() => {
  'use strict';
  // Capture phase formats display before the existing gate listeners read it.
  // Calculation engines continue receiving the same ISO dates as before.
  const selector = '[data-ae-zodiac-date-tr],input[data-ae-birth-date][type="text"],[data-ae-date-mask]';
  const field = event => event.target?.matches?.(selector) ? event.target : null;
  const digits = value => value.replace(/\D/g, '');
  function normalize(value, alternatives) {
    const iso = alternatives && /^\s*(\d{4})-(\d{2})-(\d{2})\s*$/.exec(value);
    const parts = alternatives && /^\s*(\d{1,2})\s*[./-]\s*(\d{1,2})\s*[./-]\s*(\d{4})\s*$/.exec(value);
    const raw = (iso ? iso[3] + iso[2] + iso[1] : parts ? parts[1].padStart(2, '0') + parts[2].padStart(2, '0') + parts[3] : digits(value)).slice(0, 8);
    return raw.slice(0, 2) + (raw.length > 2 ? '.' + raw.slice(2, 4) : '') + (raw.length > 4 ? '.' + raw.slice(4) : '');
  }
  function position(value, count) {
    let index = 0, seen = 0;
    while (index < value.length && seen < count) {
      if (/\d/.test(value[index])) seen++;
      index++;
    }
    if (value[index] === '.') index++;
    return index;
  }
  function format(input, alternatives = false) {
    const before = input.value, start = input.selectionStart ?? before.length, end = input.selectionEnd ?? start;
    const next = normalize(before, alternatives);
    if (next === before) return;
    input.value = next;
    // Full dates pasted in ISO or single-digit separated format have a reordered/expanded digit sequence.
    const complete = alternatives && /^(?:\s*\d{4}-\d{2}-\d{2}\s*|\s*\d{1,2}\s*[./-]\s*\d{1,2}\s*[./-]\s*\d{4}\s*)$/.test(before);
    input.setSelectionRange(complete ? next.length : position(next, digits(before.slice(0, start)).length), complete ? next.length : position(next, digits(before.slice(0, end)).length));
  }
  const notify = input => input.dispatchEvent(new Event('input', { bubbles: true }));
  document.addEventListener('input', event => { const input = field(event); if (input && !event.isComposing) format(input); }, true);
  document.addEventListener('change', event => { const input = field(event); if (input) format(input, true); }, true);
  document.addEventListener('compositionend', event => { const input = field(event); if (input) { format(input); notify(input); } }, true);
  document.addEventListener('paste', event => {
    const input = field(event), text = event.clipboardData?.getData('text');
    if (!input || !text) return;
    event.preventDefault();
    const start = input.selectionStart ?? 0, end = input.selectionEnd ?? input.value.length;
    input.value = input.value.slice(0, start) + text + input.value.slice(end);
    input.setSelectionRange(start + text.length, start + text.length);
    format(input, true); notify(input);
  }, true);
  document.addEventListener('beforeinput', event => {
    const input = field(event);
    if (!input || input.selectionStart !== input.selectionEnd) return;
    const caret = input.selectionStart;
    if (event.inputType === 'deleteContentBackward' && input.value[caret - 1] === '.') {
      event.preventDefault();
      input.value = input.value.slice(0, caret - 2) + input.value.slice(caret);
      input.setSelectionRange(caret - 2, caret - 2); format(input); notify(input);
    } else if (event.inputType === 'deleteContentForward' && input.value[caret] === '.') {
      event.preventDefault();
      input.value = input.value.slice(0, caret) + input.value.slice(caret + 2);
      input.setSelectionRange(caret, caret); format(input); notify(input);
    }
  }, true);
})();
